import React from 'react'
import { connect } from 'react-redux'
import find from 'lodash/find'
import StaticQuestionSlide from '../../slides/StaticQuestionSlide'
import QuestionCountBadge from '../../uiKit/QuestionCountBadge'
import { getQuestionBodyLabel } from '../../../utils/getQuestionBodyLabel'
import { formatDate } from '../../../utils/formatDate'
import { TILE_WIDTH, TILE_HEIGHT } from './previewConstants'

function SearchPreviewQuestion({ hit, storeQuestion }) {
  // Prefer the live Redux entity (carries bodyHtml + measurements). Fall back
  // to the hit document — which always has plain `body` but may lack bodyHtml.
  const question = storeQuestion || hit
  const editedAt = (question && question.clientModified) || (hit && hit.clientModified)
  const bodyLabel = getQuestionBodyLabel(question || { body: '' })

  return (
    <div className='searchPreviewPane searchPreviewPane--question'>
      <div className='searchPreviewPane-header'>
        <div className='searchPreviewPane-header-icon'>
          <QuestionCountBadge color='blueLight' size='medium' questionCount='–' />
        </div>
        <div className='searchPreviewPane-header-text'>
          <div className='searchPreviewPane-header-title'>{bodyLabel || 'Question'}</div>
          {editedAt && (
            <div className='searchPreviewPane-header-subtitle'>
              {'Edited '}
              {formatDate(editedAt)}
            </div>
          )}
        </div>
      </div>
      <div className='searchPreviewPane-body searchPreviewQuestion'>
        <div className='searchPreviewQuestion-slideWrapper'>
          <div
            className='searchPreviewQuestion-slide'
            style={{ width: TILE_WIDTH, height: TILE_HEIGHT }}
          >
            {question && question.bodyHtml ? (
              <StaticQuestionSlide
                question={question}
                stage='ask'
                mode='view'
                displayWidth={TILE_WIDTH - 2}
                previewCard
              />
            ) : (
              <div className='searchPreviewQuestion-fallback'>
                <QuestionCountBadge color='blueLight' size='medium' questionCount='–' />
                <div className='searchPreviewQuestion-fallback-body'>{bodyLabel}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

function mapStateToProps(state, ownProps) {
  const id = ownProps.hit && ownProps.hit.id
  return {
    storeQuestion: id ? find(state.questions, { id }) : null,
  }
}

export default connect(mapStateToProps)(SearchPreviewQuestion)
